import { useEffect, useState } from 'react'

export type DocumentDirection = 'ltr' | 'rtl'

function readDocumentDirection(): DocumentDirection {
  return typeof document !== 'undefined' && document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr'
}

/**
 * Keep portalled primitives in step with a locale switch that changes the
 * document direction after the component has mounted.
 */
export function useDocumentDirection(): DocumentDirection {
  const [direction, setDirection] = useState(readDocumentDirection)

  useEffect(() => {
    const root = document.documentElement
    const update = () => setDirection(readDocumentDirection())
    const observer = new MutationObserver(update)

    observer.observe(root, { attributes: true, attributeFilter: ['dir'] })
    update()

    return () => observer.disconnect()
  }, [])

  return direction
}
